import { Sku } from "./sku";
import { Brand } from "./brand";
import { Category } from "./category";

export class DistributionPromoDetailSku {
  private id: number;
  public get _id(): number {
    return this.id;
  }
  public set _id(value: number) {
    this.id = value;
  }
  private is_all: boolean;
  public get _is_all(): boolean {
    return this.is_all;
  }
  public set _is_all(value: boolean) {
    this.is_all = value;
  }
  private distribution_promo_detail_id: number;
  public get _distribution_promo_detail_id(): number {
    return this.distribution_promo_detail_id;
  }
  public set _distribution_promo_detail_id(value: number) {
    this.distribution_promo_detail_id = value;
  }
  private sku: Sku;
  public get _sku(): Sku {
    return this.sku;
  }
  public set _sku(value: Sku) {
    this.sku = value;
  }
  private brand: Brand;
  public get _brand(): Brand {
    return this.brand;
  }
  public set _brand(value: Brand) {
    this.brand = value;
  }
  private category: Category;
  public get _category(): Category {
    return this.category;
  }
  public set _category(value: Category) {
    this.category = value;
  }
  private mode: String;
  public get _mode(): String {
    return this.mode;
  }
  public set _mode(value: String) {
    this.mode = value;
  }

  private _disabled:boolean
  public get disabled(): boolean {
    return this._disabled;
  }
  public set disabled(value: boolean) {
    this._disabled = value;
  }
 

  // private name: string;
  // public get _name(): string {
  //   return this.name;
  // }
  // public set _name(value: string) {
  //   this.name = value;
  // }
  // private category_id: number;
  // public get _category_id(): number {
  //   return this.category_id;
  // }
  // public set _category_id(value: number) {
  //   this.category_id = value;
  // }
  // private brand_id: number;
  // public get _brand_id(): number {
  //   return this.brand_id;
  // }
  // public set _brand_id(value: number) {
  //   this.brand_id = value;
  // }
  // private sku_id: number;
  // public get _sku_id(): number {
  //   return this.sku_id;
  // }
  // public set _sku_id(value: number) {
  //   this.sku_id = value;
  // }

  constructor(id:number, distribution_promo_detail_id: number, category?: Category,brand?: Brand,sku?: Sku, public selected?: boolean) {
    if (selected === undefined) selected = false;
    

    this.id = id
    this.distribution_promo_detail_id = distribution_promo_detail_id;
    this.category = category;
    this.brand = brand;
    this.sku = sku;
    this.is_all = false
  }
}
